import React from "react";

const screenshotImage = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
  objectPosition: "top left"
};
const resultsFullPage = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center"
};
const resultsTitleText = {
  fontFamily: "Avenir-Heavy",
  fontSize: "1rem",
  color: "white",
  marginBottom: "7px",
  fontWeight: "700"
};
const resultsTitleTextRight = {
  fontFamily: "Avenir-Heavy",
  fontSize: "1rem",
  color: "white",
  marginBottom: "7px",
  fontWeight: "700",
  height: "5%",
  textAlign: "center"
};
const myColumn = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "18%"
};
const myColumnRight = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "80%"
};
const resultsBottomCenter = {
  width: "100%",
  height: "89.5%"
};
const resultsBottomFlexRow = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  height: "400px",
  gap: "2em",
  justifycontent: "space-between"
};
const resultsTextHolderScroll = {
  fontFamily: "Avenir-Roman",
  paddingLeft: "10px",
  paddingRight: "30px",
  fontSize: "1.3rem",
  lineHeight: "2.1",
  color: "white",
  maxHeight: "250px",
  minHeight: "100px",
  borderRadius: "1px",
  backgroundImage:
    "linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.6) 100%)",
  boxShadow: "var(--standard-box-shadow-color)",
  marginBottom: "20px",
  overflowY: "auto",
  scrollbarColor: "green",
  scrollbarWidth: "thin"
};
const ulStyle = {
  listStyleType: "none"
};

const ProgResults = ({
  inputValues,
  elevatorResults,
  lobbyResults,
  screenshots,
  elevatorFile,
  lfdFile,
  pfdFile
}) => {
  // Debug logging to inspect file props
  console.log("[ProgResults] screenshot:", screenshots.lobby);
  console.log("[ProgResults] elevatorFile:", elevatorFile);
  console.log("[ProgResults] lfdFile:", lfdFile);
  console.log("[ProgResults] pfdFile:", pfdFile);
  if (elevatorFile && elevatorFile.payload) {
    console.log("[ProgResults] elevatorFile.payload:", elevatorFile.payload);
  }
  if (lfdFile && lfdFile.payload) {
    console.log("[ProgResults] lfdFile.payload:", lfdFile.payload);
  }
  if (pfdFile && pfdFile.payload) {
    console.log("[ProgResults] pfdFile.payload:", pfdFile.payload);
  }
  // Helper to render a section's results
  const renderSection = (title, results) => {
    if (!results) return null;
    return (
      <div style={{ marginBottom: "2em" }}>
        <div style={resultsTitleText}>{title}</div>
        <div style={resultsTextHolderScroll}>
          <ul style={ulStyle}>
            {results.assets &&
              results.assets.map((file, idx) => (
                // <li key={file.name || idx}>{file.name}</li> //* throws an error when duplicating FSA LFD to PFD
                <li key={`${title}-${file.name || "asset"}-${idx}`}>
                  {file.name}
                </li>
              ))}
            {results.html && <li>HTML generated</li>}
            {results.lfdHtml && <li>LFD HTML generated</li>}
            {results.pfdHtml && <li>PFD HTML generated</li>}
            {results.manifest && <li>Manifest generated</li>}
          </ul>
        </div>
      </div>
    );
  };

  // Helper to render a preview for a file (image or video)
  const renderFilePreview = (file, label) => {
    if (!file || !file.payload) return null;
    const type = file.payload.type || "";
    const url = URL.createObjectURL(file.payload);
    // Define custom styles for each label
    let customImgStyle = { maxWidth: "100%" };
    if (label === "Elevator") {
      customImgStyle = {
        ...customImgStyle,
        border: "2px solid #4caf50",
        aspectRatio: "4 / 3"
      };
    } else if (label === "Lobby (LFD)") {
      customImgStyle = {
        ...customImgStyle,
        border: "2px solid #2196f3",
        aspectRatio: "16 / 9"
      };
    } else if (label === "Portrait (PFD)") {
      customImgStyle = {
        ...customImgStyle,
        border: "2px solid #ff9800",
        width: "auto",
        height: "auto",
        maxHeight: "100%"
      };
    }
    return (
      <div className="eachPrieviewColumn">
        <div className="prieviewHeader">{label}</div>
        {type.startsWith("video") ? (
          <video style={{ maxWidth: "100%" }} controls loop>
            <source src={url} />
          </video>
        ) : (
          <img style={customImgStyle} src={url} alt={label + " preview"} />
        )}
      </div>
    );
  };

  //* Qestion, why would we even want to return the screenshot over the renderFilePreview???
  //* this might be the reason why we are not getting video playback
  return (
    <div className="resultsFullPage" style={resultsFullPage}>
      {/* <div className="columnLeft" style={myColumn}>
        {renderSection("ELEVATOR OUTPUT", elevatorResults)}
        {renderSection("LOBBY OUTPUT", lobbyResults)}
      </div> */}
      <div className="columnCenter" style={myColumnRight}>
        <div className="resultsTopCenter" style={resultsTitleTextRight}>
          PREVIEW
        </div>
        <div className="resultsBottomCenter" style={resultsBottomCenter}>
          {screenshots.elevator && screenshots.lobby ? (
            <div>
              <img
                style={screenshotImage}
                src={screenshots.elevator}
                alt="preview-ele"
              />
              <img
                style={screenshotImage}
                src={screenshots.lobby}
                alt="preview-lby"
              />
            </div>
          ) : (
            <div className="resultsBottomFlexRow" style={resultsBottomFlexRow}>
              {renderFilePreview(elevatorFile, "Elevator")}
              {renderFilePreview(lfdFile, "Lobby (LFD)")}
              {renderFilePreview(pfdFile, "Portrait (PFD)")}
              {!(
                (elevatorFile && elevatorFile.payload) ||
                (lfdFile && lfdFile.payload) ||
                (pfdFile && pfdFile.payload)
              ) && (
                <div style={{ color: "#ccc", textAlign: "center" }}>
                  No preview available
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgResults;
